import React from 'react';
import './TopNavigation.css'; // Создадим этот файл для стилей

// Иконки можно импортировать как SVG или использовать символы/библиотеку иконок
// Пример с SVG-строками (упрощенно, лучше использовать import как компоненты)

// Иконки сохраняем для возможного использования в будущем

const TopNavigation = ({ onSectionChange, activeSection, unreadNotifications = 0 }) => {
  // Мы скрываем верхнее меню, так как теперь используем нижнее меню
  return null;
};

export default TopNavigation; 